import { FC, useEffect, useState } from 'react';

import { CompanyDetailType } from '@type-def_iqfu/CompanyType';

import { CommissionRateTypeKey } from '@constants_iqfu';

import styles from './RightColumnCommissionRateTypeKey.module.scss';

type Props = {
  companyData: CompanyDetailType;
};

const RightColumnCommissionRateTypeKey: FC<Props> = ({ companyData }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const commissionRates = {
    standard: {
      commissionFee: '30',
      generalAgencyMinimumFee: '9',
      purchasePrice: '1.5%',
      purchaseAgencyMinimumFee: '12',
    },
    c21: {
      commissionFee: '28',
      generalAgencyMinimumFee: '9',
      purchasePrice: '1.45%',
      purchaseAgencyMinimumFee: '12',
    },
    asolie: {
      commissionFee: '50',
      generalAgencyMinimumFee: '15',
      purchasePrice: '3％＋6万円',
      purchaseAgencyMinimumFee: '30',
    },
  };
  const {
    commissionFee = '',
    generalAgencyMinimumFee = '',
    purchasePrice = '',
    purchaseAgencyMinimumFee = '',
  } = commissionRates[companyData.commission_rate_type_key] || {};

  useEffect(() => {
    setIsOpen(false);
  }, [companyData.id]);

  return (
    <>
      <div className={styles.right_column_container_item}>
        <div className={styles.right_column_container_commission_rate_type_key_area}>
          <p className={styles.right_column_container_commission_rate_type_key_area_title}>手数料タイプ</p>
        </div>
        <div className={styles.right_column_container_commission_rate_type_key_area_wrapper}>
          <div className={styles.right_column_container_value_label}>
            <p className={`${styles.right_column_container_value_label} ${styles.bold}`}>
              {CommissionRateTypeKey[companyData.commission_rate_type_key]}
            </p>
            <a
              className={styles.commission_rate_type_key_detail_link}
              onClick={() => {
                setIsOpen((prev) => !prev);
              }}
            >
              {isOpen ? '閉じる' : '開く'}
            </a>
          </div>
        </div>
        {isOpen && (
          <div className={styles.right_column_container_commission_rate_type_key_wrapper}>
            <p className={styles.right_column_container_commission_rate_type_key_wrapper_title}>【仲介】</p>
            <p className={styles.right_column_container_commission_rate_type_key_wrapper_content}>
              仲介手数料（税抜）の{commissionFee}％＋税
            </p>
            <p className={styles.right_column_container_commission_rate_type_key_wrapper_content}>
              最低手数料額：{generalAgencyMinimumFee}万円＋税
            </p>
            <p className={styles.right_column_container_commission_rate_type_key_wrapper_title}>【買取】</p>
            <p className={styles.right_column_container_commission_rate_type_key_wrapper_content}>
              売買代金の{purchasePrice}＋税
            </p>
            <p className={styles.right_column_container_commission_rate_type_key_wrapper_content}>
              最低手数料額：{purchaseAgencyMinimumFee}万円＋税
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default RightColumnCommissionRateTypeKey;
